import React from 'react';

const Truck = props => (
  <svg width="23px" height="14px" viewBox="0 0 23 14" {...props}>
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Request-for-transportation"
        transform="translate(-1141.000000, -160.000000)"
        fill="#FFFFFF"
        fillRule="nonzero"
      >
        <g
          id="request-info---tabs"
          transform="translate(1079.000000, 146.000000)"
        >
          <path
            d="M68.9499909,26 C68.7183558,27.1411202 67.709479,28 66.5,28 C65.290521,28 64.2816442,27.1411202 64.0500091,26 L62.7,26 C62.3134007,26 62,25.6865993 62,25.3 L62,21.2328999 C62,21.1043149 62.041309,20.9791313 62.1178385,20.8758001 L65.5490705,16.2429001 C65.6622281,16.0901131 65.8411042,16 66.0312319,16 L70,16 L70,14.7 C70,14.3134007 70.3134007,14 70.7,14 L84.3,14 C84.6865993,14 85,14.3134007 85,14.7 L85,25.3 C85,25.6865993 84.6865993,26 84.3,26 L81.9499909,26 C81.7183558,27.1411202 80.709479,28 79.5,28 C78.290521,28 77.2816442,27.1411202 77.0500091,26 L71,26 L68.9499909,26 Z M68.9499909,25 L70,25 L70,17 L66.2327413,17 L65.4921184,18 L68,18 C68.5522847,18 69,18.4477153 69,19 L69,21 C69,21.5522847 68.5522847,22 68,22 L63,22 L63,25 L64.0500091,25 C64.2816442,23.8588798 65.290521,23 66.5,23 C67.709479,23 68.7183558,23.8588798 68.9499909,25 Z M77.0500091,25 C77.2816442,23.8588798 78.290521,23 79.5,23 C80.709479,23 81.7183558,23.8588798 81.9499909,25 L84,25 L84,21.9952014 L73.5,21.9952014 C73.2238576,21.9952014 73,21.7713438 73,21.4952014 C73,21.219059 73.2238576,20.9952014 73.5,20.9952014 L84,20.9952014 L84,15 L71,15 L71,16.5 L71,17 L73.5,17 C73.7761424,17 74,17.2238576 74,17.5 C74,17.7761424 73.7761424,18 73.5,18 L71,18 L71,25 L77.0500091,25 Z M64.7514954,19 L63.2702496,21 L68,21 L68,19 L64.7514954,19 Z M79.5,27 C80.3284271,27 81,26.3284271 81,25.5 C81,24.6715729 80.3284271,24 79.5,24 C78.6715729,24 78,24.6715729 78,25.5 C78,26.3284271 78.6715729,27 79.5,27 Z M66.5,27 C67.3284271,27 68,26.3284271 68,25.5 C68,24.6715729 67.3284271,24 66.5,24 C65.6715729,24 65,24.6715729 65,25.5 C65,26.3284271 65.6715729,27 66.5,27 Z"
            id="truck"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export default Truck;
